import type { FilterOptions } from '@/entities/Document';

export function hasActiveFilterValues(filter: FilterOptions): boolean {
  if (!filter || typeof filter !== 'object') {
    return false;
  }

  const entries = Object.entries(filter as Record<string, unknown>);
  for (const [key, value] of entries) {
    if (value === null || value === undefined || value === '') {
      continue;
    }
    if (key === 'revision' && typeof value === 'number' && value <= 0) {
      continue;
    }
    if (value instanceof Date) {
      return true;
    }
    if (typeof value === 'boolean') {
      return true;
    }
    if (typeof value === 'string' && value.trim() !== '') {
      return true;
    }
    if (typeof value === 'number' && value !== 0) {
      return true;
    }
  }
  return false;
}
